function shareArtDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/share-art/share-art-dialog.html?$$REVISION$$'
  }
}

export { shareArtDialog }
